import { render, staticRenderFns } from "./TogglePrivateDeckButton.vue?vue&type=template&id=38534502"
import script from "./TogglePrivateDeckButton.vue?vue&type=script&lang=js"
export * from "./TogglePrivateDeckButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports